var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Category reports preview",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -23)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 122,
    width: 240,
    height: 168,
    rx: 12,
    fill: "#FAFAFA",
    stroke: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: 232,
    width: 32,
    height: 44,
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 206,
    width: 32,
    height: 70,
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 184,
    width: 32,
    height: 92,
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 156,
    width: 32,
    height: 120,
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 214,
    width: 32,
    height: 62,
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 276,
    x2: 564,
    y2: 276,
    stroke: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360,
    y1: 156,
    x2: 564,
    y2: 156,
    stroke: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 198,
    r: 82,
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L300 116 A82 82 0 0 1 383.1 180.7 Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L383.1 180.7 A82 82 0 0 1 325.8 279.9 Z",
    fill: "#42A5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L325.8 279.9 A82 82 0 0 1 224.4 238.5 Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L224.4 238.5 A82 82 0 0 1 252.9 132.2 Z",
    fill: "#AB47BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 198 L252.9 132.2 A82 82 0 0 1 300 116 Z",
    fill: "#FFD54F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryReports);
export default __webpack_public_path__ + "static/media/category-reports.5033d1274d66116fc78ad7bdc1e7e1e3.svg";
export { ForwardRef as ReactComponent };